// extracted by mini-css-extract-plugin
export default {"productGallery":"CM-z","inQuickShop":"DM-z"};